// extracted by mini-css-extract-plugin
module.exports = {"gradientButton":"Header_gradientButton__XwnoZ","empty":"Header_empty__sl23U","select":"Header_select__3MUn8","selectDark":"Header_selectDark__2UhPg","input":"Header_input__33yby"};